import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { useRef, useEffect, createElement, memo, Fragment, useState, useCallback, useMemo, useContext, forwardRef } from 'react';
import 'prop-types';
import { u as useUtils, a as DAY_MARGIN, b as useNow } from './dimensions-bd426990.js';
export { L as LocalizationProvider, M as MuiPickersContext, u as useUtils } from './dimensions-bd426990.js';
import clsx from 'clsx';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@material-ui/core/IconButton';
import '@material-ui/core/Toolbar';
import '@material-ui/core/utils';
import { P as PickerToolbar, d as ToolbarButton } from './ClockView-03c73477.js';
export { C as ClockView, a as TimePickerView } from './ClockView-03c73477.js';
import { a as useNextMonthDisabled, b as usePreviousMonthDisabled, A as ArrowSwitcher, u as useParsedDate } from './ArrowSwitcher-b0a281b3.js';
import { makeStyles, fade } from '@material-ui/core/styles';
import '@babel/runtime/helpers/esm/typeof';
import { m as mergeRefs, d as doNothing, c as createDelegatedEventHandler } from './utils-66277a98.js';
import { C as Calendar, c as isWithinRange, d as isStartOfRange, e as isEndOfRange, f as isRangeValid, p as parsePickerInputValue } from './Calendar-afaf51ae.js';
export { C as Calendar } from './Calendar-afaf51ae.js';
export { DatePicker, DesktopDatePicker, MobileDatePicker, StaticDatePicker } from './DatePicker.js';
import { b as makeWrapperComponent, c as ResponsivePopperWrapper, e as DesktopPopperWrapper, M as MobileWrapper, S as StaticWrapper } from './Wrapper-4adf0bef.js';
export { m as makePickerWithState } from './Wrapper-4adf0bef.js';
import '@material-ui/core/useMediaQuery';
import '@material-ui/core/Button';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/Dialog';
import '@material-ui/core/TextField';
import { K as KeyboardDateInput, C as CalendarHeader, c as useCalendarState, M as MobileKeyboardInputView, d as defaultReduceAnimations } from './Picker-2bbc7ba8.js';
export { f as CalendarView, P as Picker, d as defaultReduceAnimations, e as useStyles, v as validate } from './Picker-2bbc7ba8.js';
import { W as WrapperVariantContext } from './WrapperVariantContext-747fba40.js';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import '@material-ui/core/InputAdornment';
import 'rifm';
import '@material-ui/core/Popover';
import '@material-ui/core/Grow';
import '@material-ui/core/Paper';
import '@material-ui/core/Modal/TrapFocus';
import '@material-ui/core/Popper';
import './useKeyDown-e9a6112c.js';
import { F as FORCE_FINISH_PICKER, u as usePickerState } from './usePickerState-71de5ec1.js';
export { u as usePickerState } from './usePickerState-71de5ec1.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/inherits';
export { C as Clock } from './Clock-9baa7a72.js';
import '@material-ui/core/ButtonBase';
import '@material-ui/core/CircularProgress';
import 'react-transition-group';
import { areDayPropsEqual, Day } from './Day.js';
export { Day } from './Day.js';
import '@material-ui/core/Fade';
export { DesktopTimePicker, MobileTimePicker, StaticTimePicker, TimePicker, getTextFieldAriaText } from './TimePicker.js';
import '@material-ui/core/Tab';
import '@material-ui/core/Tabs';
export { DateTimePicker, DesktopDateTimePicker, MobileDateTimePicker, StaticDateTimePicker } from './DateTimePicker.js';

function calculateRangeChange(_ref) {
  var utils = _ref.utils,
      range = _ref.range,
      selectedDate = _ref.newDate,
      currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd;

  var _range = _slicedToArray(range, 2),
      start = _range[0],
      end = _range[1];

  if (currentlySelectingRangeEnd === 'start') {
    return Boolean(end) && utils.isAfter(selectedDate, end) ? {
      nextSelection: 'end',
      newRange: [selectedDate, null]
    } : {
      nextSelection: 'end',
      newRange: [selectedDate, end]
    };
  } else {
    return Boolean(start) && utils.isBefore(selectedDate, start) ? {
      nextSelection: 'end',
      newRange: [selectedDate, null]
    } : {
      nextSelection: 'start',
      newRange: [start, selectedDate]
    };
  }
}
function calculateRangePreview(options) {
  if (!options.newDate) {
    return [null, null];
  }

  var _options$range = _slicedToArray(options.range, 2),
      start = _options$range[0],
      end = _options$range[1];

  var _calculateRangeChange = calculateRangeChange(options),
      newRange = _calculateRangeChange.newRange;

  if (!start || !end) {
    return newRange;
  }

  var _newRange = _slicedToArray(newRange, 2),
      previewStart = _newRange[0],
      previewEnd = _newRange[1]; // prettier-ignore


  return options.currentlySelectingRangeEnd === 'end' ? [end, previewEnd] : [previewStart, start];
}

var useStyles = makeStyles(function (theme) {
  return {
    rangeInputsContainer: _defineProperty({
      display: 'flex',
      alignItems: 'center'
    }, theme.breakpoints.down('xs'), {
      flexDirection: 'column'
    }),
    toLabelDelimiter: _defineProperty({
      margin: '8px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '0 16px'
    })
  };
}, {
  name: 'MuiPickersDateRangePickerInput'
});
var DateRangePickerInput = function DateRangePickerInput(_ref) {
  var _ref$toText = _ref.toText,
      toText = _ref$toText === void 0 ? 'to' : _ref$toText,
      rawValue = _ref.rawValue,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      _ref$parsedDateValue = _slicedToArray(_ref.parsedDateValue, 2),
      start = _ref$parsedDateValue[0],
      end = _ref$parsedDateValue[1],
      id = _ref.id,
      open = _ref.open,
      className = _ref.className,
      containerRef = _ref.containerRef,
      forwardedRef = _ref.forwardedRef,
      currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd = _ref.setCurrentlySelectingRangeEnd,
      openPicker = _ref.openPicker,
      onFocus = _ref.onFocus,
      readOnly = _ref.readOnly,
      disableOpenPicker = _ref.disableOpenPicker,
      startText = _ref.startText,
      endText = _ref.endText,
      other = _objectWithoutProperties(_ref, ["toText", "rawValue", "onChange", "onClick", "parsedDateValue", "id", "open", "className", "containerRef", "forwardedRef", "currentlySelectingRangeEnd", "setCurrentlySelectingRangeEnd", "openPicker", "onFocus", "readOnly", "disableOpenPicker", "startText", "endText"]);

  var utils = useUtils();
  var classes = useStyles();
  var startRef = useRef(null);
  var endRef = useRef(null);
  useEffect(function () {
    if (!open) {
      return;
    }

    if (currentlySelectingRangeEnd === 'start') {
      var _startRef$current;

      (_startRef$current = startRef.current) === null || _startRef$current === void 0 ? void 0 : _startRef$current.focus();
    } else if (currentlySelectingRangeEnd === 'end') {
      var _endRef$current;

      (_endRef$current = endRef.current) === null || _endRef$current === void 0 ? void 0 : _endRef$current.focus();
    }
  }, [currentlySelectingRangeEnd, open]);

  var handleStartChange = function handleStartChange(date, inputString) {
    if (date === null || utils.isValid(date)) {
      onChange([date, end], inputString);
    }
  };

  var handleEndChange = function handleEndChange(date, inputString) {
    if (date === null || utils.isValid(date)) {
      onChange([start, date], inputString);
    }
  };

  var openRangeStartSelection = function openRangeStartSelection() {
    if (setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('start');
    }

    if (!disableOpenPicker) {
      openPicker();
    }
  };

  var openRangeEndSelection = function openRangeEndSelection() {
    if (setCurrentlySelectingRangeEnd) {
      setCurrentlySelectingRangeEnd('end');
    }

    if (!disableOpenPicker) {
      openPicker();
    }
  };

  return createElement("div", {
    id: id,
    className: clsx(classes.rangeInputsContainer, className),
    ref: mergeRefs([containerRef, forwardedRef])
  }, createElement(KeyboardDateInput, _extends({}, other, {
    open: open,
    forwardedRef: startRef,
    rawValue: start,
    parsedDateValue: start,
    onChange: handleStartChange,
    disableOpenPicker: true,
    openPicker: doNothing,
    readOnly: readOnly,
    label: startText,
    focused: open && currentlySelectingRangeEnd === 'start',
    onClick: readOnly ? createDelegatedEventHandler(openRangeStartSelection, onClick) : undefined,
    onFocus: !readOnly ? createDelegatedEventHandler(openRangeStartSelection, onFocus) : undefined
  })), createElement(Typography, {
    className: classes.toLabelDelimiter
  }, toText), createElement(KeyboardDateInput, _extends({}, other, {
    open: open,
    forwardedRef: endRef,
    rawValue: end,
    parsedDateValue: end,
    onChange: handleEndChange,
    disableOpenPicker: true,
    openPicker: doNothing,
    readOnly: readOnly,
    label: endText,
    focused: open && currentlySelectingRangeEnd === 'end',
    onClick: readOnly ? createDelegatedEventHandler(openRangeEndSelection, onClick) : undefined,
    onFocus: !readOnly ? createDelegatedEventHandler(openRangeEndSelection, onFocus) : undefined
  })));
};

var useStyles$1 = makeStyles({
  penIcon: {
    position: 'relative',
    top: 4
  },
  dateTextContainer: {
    display: 'flex'
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DateRangePickerToolbar = function DateRangePickerToolbar(_ref) {
  var _ref$date = _slicedToArray(_ref.date, 2),
      start = _ref$date[0],
      end = _ref$date[1],
      toolbarFormat = _ref.toolbarFormat,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd = _ref.setCurrentlySelectingRangeEnd,
      startText = _ref.startText,
      endText = _ref.endText,
      _ref$toolbarTitle = _ref.toolbarTitle,
      toolbarTitle = _ref$toolbarTitle === void 0 ? 'SELECT DATE RANGE' : _ref$toolbarTitle;

  var utils = useUtils();
  var classes = useStyles$1();
  var startDateValue = start ? utils.formatByString(start, toolbarFormat || utils.formats.shortDate) : startText;
  var endDateValue = end ? utils.formatByString(end, toolbarFormat || utils.formats.shortDate) : endText;
  return createElement(PickerToolbar, {
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: false,
    penIconClassName: classes.penIcon
  }, createElement("div", {
    className: classes.dateTextContainer
  }, createElement(ToolbarButton, {
    variant: Boolean(start) ? 'h5' : 'h6',
    value: startDateValue,
    selected: currentlySelectingRangeEnd === 'start',
    onClick: function onClick() {
      return setCurrentlySelectingRangeEnd('start');
    }
  }), createElement(Typography, {
    variant: "h5"
  }, "\xA0", '–', "\xA0"), createElement(ToolbarButton, {
    variant: Boolean(end) ? 'h5' : 'h6',
    value: endDateValue,
    selected: currentlySelectingRangeEnd === 'end',
    onClick: function onClick() {
      return setCurrentlySelectingRangeEnd('end');
    }
  })));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var endBorderStyle = {
  borderTopRightRadius: '50%',
  borderBottomRightRadius: '50%'
};
var startBorderStyle = {
  borderTopLeftRadius: '50%',
  borderBottomLeftRadius: '50%'
};
var useStyles$2 = makeStyles(function (theme) {
  return {
    rangeIntervalDay: {
      '&:first-child $rangeIntervalDayPreview': _objectSpread({}, startBorderStyle, {
        borderLeftColor: theme.palette.divider
      }),
      '&:last-child $rangeIntervalDayPreview': _objectSpread({}, endBorderStyle, {
        borderRightColor: theme.palette.divider
      })
    },
    rangeIntervalDayHighlight: {
      borderRadius: 0,
      color: theme.palette.primary.contrastText,
      backgroundColor: fade(theme.palette.primary.light, 0.6),
      '&:first-child': startBorderStyle,
      '&:last-child': endBorderStyle
    },
    rangeIntervalDayHighlightStart: _objectSpread({}, startBorderStyle, {
      paddingLeft: 0,
      marginLeft: DAY_MARGIN / 2
    }),
    rangeIntervalDayHighlightEnd: _objectSpread({}, endBorderStyle, {
      paddingRight: 0,
      marginRight: DAY_MARGIN / 2
    }),
    day: {
      // Required to overlap preview border
      transform: 'scale(1.1)',
      '& > *': {
        transform: 'scale(0.9)'
      }
    },
    dayOutsideRangeInterval: {
      '&:hover': {
        border: "1px solid ".concat(theme.palette.grey[500])
      }
    },
    dayInsideRangeInterval: {
      color: theme.palette.getContrastText(fade(theme.palette.primary.light, 0.6))
    },
    notSelectedDate: {
      backgroundColor: 'transparent'
    },
    rangeIntervalPreview: {
      // replace default day component margin with transparent border to avoid jumping on preview
      border: '2px solid transparent'
    },
    rangeIntervalDayPreview: {
      borderRadius: 0,
      border: "2px dashed ".concat(theme.palette.divider),
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent',
      '&$rangeIntervalDayPreviewStart': _objectSpread({
        borderLeftColor: theme.palette.divider
      }, startBorderStyle),
      '&$rangeIntervalDayPreviewEnd': _objectSpread({
        borderRightColor: theme.palette.divider
      }, endBorderStyle)
    },
    rangeIntervalDayPreviewStart: {},
    rangeIntervalDayPreviewEnd: {}
  };
}, {
  name: 'MuiPickersDateRangeDay'
});
var PureDateRangeDay = function PureDateRangeDay(_ref) {
  var day = _ref.day,
      className = _ref.className,
      selected = _ref.selected,
      isPreviewing = _ref.isPreviewing,
      isStartOfPreviewing = _ref.isStartOfPreviewing,
      isEndOfPreviewing = _ref.isEndOfPreviewing,
      isHighlighting = _ref.isHighlighting,
      isEndOfHighlighting = _ref.isEndOfHighlighting,
      isStartOfHighlighting = _ref.isStartOfHighlighting,
      inCurrentMonth = _ref.inCurrentMonth,
      other = _objectWithoutProperties(_ref, ["day", "className", "selected", "isPreviewing", "isStartOfPreviewing", "isEndOfPreviewing", "isHighlighting", "isEndOfHighlighting", "isStartOfHighlighting", "inCurrentMonth"]);

  var utils = useUtils();
  var classes = useStyles$2();
  var isEndOfMonth = utils.isSameDay(day, utils.endOfMonth(day));
  var isStartOfMonth = utils.isSameDay(day, utils.startOfMonth(day));
  var shouldRenderHighlight = isHighlighting && inCurrentMonth;
  var shouldRenderPreview = isPreviewing && inCurrentMonth;
  return createElement("div", {
    "data-mui-test": shouldRenderHighlight ? 'DateRangeHighlight' : undefined,
    className: clsx(classes.rangeIntervalDay, (isEndOfHighlighting || isEndOfMonth) && classes.rangeIntervalDayHighlightEnd, (isStartOfHighlighting || isStartOfMonth) && classes.rangeIntervalDayHighlightStart, shouldRenderHighlight && classes.rangeIntervalDayHighlight)
  }, createElement("div", {
    "data-mui-test": shouldRenderPreview ? 'DateRangePreview' : undefined,
    className: clsx(classes.rangeIntervalPreview, (isEndOfPreviewing || isEndOfMonth) && classes.rangeIntervalDayPreviewEnd, (isStartOfPreviewing || isStartOfMonth) && classes.rangeIntervalDayPreviewStart, shouldRenderPreview && classes.rangeIntervalDayPreview)
  }, createElement(Day, _extends({
    allowKeyboardControl: false,
    disableMargin: true
  }, other, {
    day: day,
    selected: selected,
    inCurrentMonth: inCurrentMonth,
    "data-mui-test": "DateRangeDay",
    className: clsx(classes.day, className, !selected && [classes.notSelectedDate, isHighlighting && classes.dayInsideRangeInterval], !isHighlighting && classes.dayOutsideRangeInterval)
  }))));
};
PureDateRangeDay.displayName = 'DateRangeDay';
var DateRangeDay = memo(PureDateRangeDay, function (prevProps, nextProps) {
  return prevProps.isHighlighting === nextProps.isHighlighting && prevProps.isEndOfHighlighting === nextProps.isEndOfHighlighting && prevProps.isStartOfHighlighting === nextProps.isStartOfHighlighting && prevProps.isPreviewing === nextProps.isPreviewing && prevProps.isEndOfPreviewing === nextProps.isEndOfPreviewing && prevProps.isStartOfPreviewing === nextProps.isStartOfPreviewing && areDayPropsEqual(prevProps, nextProps);
});

var onlyDateView = ['date'];
var DateRangePickerViewMobile = function DateRangePickerViewMobile(_ref) {
  var date = _ref.date,
      changeMonth = _ref.changeMonth,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      leftArrowButtonText = _ref.leftArrowButtonText,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      rightArrowButtonText = _ref.rightArrowButtonText,
      rightArrowIcon = _ref.rightArrowIcon,
      onChange = _ref.onChange,
      other = _objectWithoutProperties(_ref, ["date", "changeMonth", "leftArrowButtonProps", "leftArrowButtonText", "leftArrowIcon", "rightArrowButtonProps", "rightArrowButtonText", "rightArrowIcon", "onChange"]);

  var utils = useUtils();
  return createElement(Fragment, null, createElement(CalendarHeader, _extends({
    view: "date",
    views: onlyDateView,
    changeView: function changeView() {
      return {};
    },
    onMonthChange: changeMonth,
    leftArrowButtonProps: leftArrowButtonProps,
    leftArrowButtonText: leftArrowButtonText,
    leftArrowIcon: leftArrowIcon,
    rightArrowButtonProps: rightArrowButtonProps,
    rightArrowButtonText: rightArrowButtonText,
    rightArrowIcon: rightArrowIcon
  }, other)), createElement(Calendar, _extends({}, other, {
    date: date,
    onChange: onChange,
    renderDay: function renderDay(day, _, DayProps) {
      return createElement(DateRangeDay, _extends({
        isPreviewing: false,
        isStartOfPreviewing: false,
        isEndOfPreviewing: false,
        isHighlighting: isWithinRange(utils, day, date),
        isStartOfHighlighting: isStartOfRange(utils, day, date),
        isEndOfHighlighting: isEndOfRange(utils, day, date)
      }, DayProps));
    }
  })));
};

var useStyles$3 = makeStyles(function (theme) {
  return {
    dateRangeContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    rangeCalendarContainer: {
      '&:not(:last-child)': {
        borderRight: "2px solid ".concat(theme.palette.divider)
      }
    },
    calendar: {
      minWidth: 312,
      minHeight: 288
    },
    arrowSwitcher: {
      padding: '16px 16px 8px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  };
}, {
  name: 'MuiPickersDesktopDateRangeCalendar'
});

function getCalendarsArray(calendars) {
  switch (calendars) {
    case 1:
      return [0];

    case 2:
      return [0, 0];

    case 3:
      return [0, 0, 0];
    // this will not work in IE11, but allows to support any amount of calendars

    default:
      return new Array(calendars).fill(0);
  }
}

var DateRangePickerViewDesktop = function DateRangePickerViewDesktop(_ref) {
  var date = _ref.date,
      _ref$calendars = _ref.calendars,
      calendars = _ref$calendars === void 0 ? 2 : _ref$calendars,
      changeMonth = _ref.changeMonth,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      leftArrowButtonText = _ref.leftArrowButtonText,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      rightArrowButtonText = _ref.rightArrowButtonText,
      rightArrowIcon = _ref.rightArrowIcon,
      onChange = _ref.onChange,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd,
      currentMonth = _ref.currentMonth,
      other = _objectWithoutProperties(_ref, ["date", "calendars", "changeMonth", "leftArrowButtonProps", "leftArrowButtonText", "leftArrowIcon", "rightArrowButtonProps", "rightArrowButtonText", "rightArrowIcon", "onChange", "disableFuture", "disablePast", "minDate", "maxDate", "currentlySelectingRangeEnd", "currentMonth"]);

  var utils = useUtils();
  var classes = useStyles$3();

  var _React$useState = useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      rangePreviewDay = _React$useState2[0],
      setRangePreviewDay = _React$useState2[1];

  var isNextMonthDisabled = useNextMonthDisabled(currentMonth, {
    disableFuture: disableFuture,
    maxDate: maxDate
  });
  var isPreviousMonthDisabled = usePreviousMonthDisabled(currentMonth, {
    disablePast: disablePast,
    minDate: minDate
  });
  var previewingRange = calculateRangePreview({
    utils: utils,
    range: date,
    newDate: rangePreviewDay,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd
  });
  var handleDayChange = useCallback(function (day) {
    setRangePreviewDay(null);
    onChange(day);
  }, [onChange]);

  var handlePreviewDayChange = function handlePreviewDayChange(newPreviewRequest) {
    if (!isWithinRange(utils, newPreviewRequest, date)) {
      setRangePreviewDay(newPreviewRequest);
    } else {
      setRangePreviewDay(null);
    }
  };

  var CalendarTransitionProps = useMemo(function () {
    return {
      onMouseLeave: function onMouseLeave() {
        return setRangePreviewDay(null);
      }
    };
  }, []);
  var selectNextMonth = useCallback(function () {
    changeMonth(utils.getNextMonth(currentMonth));
  }, [changeMonth, currentMonth, utils]);
  var selectPreviousMonth = useCallback(function () {
    changeMonth(utils.getPreviousMonth(currentMonth));
  }, [changeMonth, currentMonth, utils]);
  return createElement("div", {
    className: classes.dateRangeContainer
  }, getCalendarsArray(calendars).map(function (_, index) {
    var monthOnIteration = utils.setMonth(currentMonth, utils.getMonth(currentMonth) + index);
    return createElement("div", {
      key: index,
      className: classes.rangeCalendarContainer
    }, createElement(ArrowSwitcher, {
      className: classes.arrowSwitcher,
      onLeftClick: selectPreviousMonth,
      onRightClick: selectNextMonth,
      isLeftHidden: index !== 0,
      isRightHidden: index !== calendars - 1,
      isLeftDisabled: isPreviousMonthDisabled,
      isRightDisabled: isNextMonthDisabled,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowButtonText: leftArrowButtonText,
      leftArrowIcon: leftArrowIcon,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowButtonText: rightArrowButtonText,
      rightArrowIcon: rightArrowIcon,
      text: utils.format(monthOnIteration, 'monthAndYear')
    }), createElement(Calendar, _extends({}, other, {
      key: index,
      date: date,
      minDate: minDate,
      maxDate: maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      className: classes.calendar,
      onChange: handleDayChange,
      currentMonth: monthOnIteration,
      TransitionProps: CalendarTransitionProps,
      renderDay: function renderDay(day, _, DayProps) {
        return createElement(DateRangeDay, _extends({
          isPreviewing: isWithinRange(utils, day, previewingRange),
          isStartOfPreviewing: isStartOfRange(utils, day, previewingRange),
          isEndOfPreviewing: isEndOfRange(utils, day, previewingRange),
          isHighlighting: isWithinRange(utils, day, date),
          isStartOfHighlighting: isStartOfRange(utils, day, date),
          isEndOfHighlighting: isEndOfRange(utils, day, date),
          onMouseEnter: function onMouseEnter() {
            return handlePreviewDayChange(day);
          }
        }, DayProps));
      }
    })));
  }));
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DateRangePickerView = function DateRangePickerView(_ref) {
  var open = _ref.open,
      _ref$calendars = _ref.calendars,
      calendars = _ref$calendars === void 0 ? 2 : _ref$calendars,
      currentlySelectingRangeEnd = _ref.currentlySelectingRangeEnd,
      date = _ref.date,
      _ref$disableAutoMonth = _ref.disableAutoMonthSwitching,
      disableAutoMonthSwitching = _ref$disableAutoMonth === void 0 ? false : _ref$disableAutoMonth,
      disableFuture = _ref.disableFuture,
      disableHighlightToday = _ref.disableHighlightToday,
      disablePast = _ref.disablePast,
      _ref$maxDate = _ref.maxDate,
      unparsedMaxDate = _ref$maxDate === void 0 ? new Date('2100-01-01') : _ref$maxDate,
      _ref$minDate = _ref.minDate,
      unparsedMinDate = _ref$minDate === void 0 ? new Date('1900-01-01') : _ref$minDate,
      onDateChange = _ref.onDateChange,
      onMonthChange = _ref.onMonthChange,
      _ref$reduceAnimations = _ref.reduceAnimations,
      reduceAnimations = _ref$reduceAnimations === void 0 ? defaultReduceAnimations : _ref$reduceAnimations,
      setCurrentlySelectingRangeEnd = _ref.setCurrentlySelectingRangeEnd,
      shouldDisableDate = _ref.shouldDisableDate,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      showToolbar = _ref.showToolbar,
      startText = _ref.startText,
      endText = _ref.endText,
      DateInputProps = _ref.DateInputProps,
      other = _objectWithoutProperties(_ref, ["open", "calendars", "currentlySelectingRangeEnd", "date", "disableAutoMonthSwitching", "disableFuture", "disableHighlightToday", "disablePast", "maxDate", "minDate", "onDateChange", "onMonthChange", "reduceAnimations", "setCurrentlySelectingRangeEnd", "shouldDisableDate", "toggleMobileKeyboardView", "isMobileKeyboardViewOpen", "showToolbar", "startText", "endText", "DateInputProps"]);

  var now = useNow();
  var utils = useUtils();
  var wrapperVariant = useContext(WrapperVariantContext);
  var minDate = useParsedDate(unparsedMinDate);
  var maxDate = useParsedDate(unparsedMaxDate);

  var _date = _slicedToArray(date, 2),
      start = _date[0],
      end = _date[1];

  var _useCalendarState = useCalendarState({
    date: start || end || now,
    minDate: minDate,
    maxDate: maxDate,
    reduceAnimations: reduceAnimations,
    disablePast: disablePast,
    disableFuture: disableFuture,
    onMonthChange: onMonthChange,
    shouldDisableDate: shouldDisableDate,
    disableSwitchToMonthOnDayFocus: true
  }),
      changeMonth = _useCalendarState.changeMonth,
      calendarState = _useCalendarState.calendarState,
      isDateDisabled = _useCalendarState.isDateDisabled,
      onMonthSwitchingAnimationEnd = _useCalendarState.onMonthSwitchingAnimationEnd,
      changeFocusedDay = _useCalendarState.changeFocusedDay;

  var toShowToolbar = showToolbar !== null && showToolbar !== void 0 ? showToolbar : wrapperVariant !== 'desktop';

  var scrollToDayIfNeeded = function scrollToDayIfNeeded(day) {
    var displayingMonthRange = wrapperVariant === 'mobile' ? 0 : calendars - 1;
    var currentMonthNumber = utils.getMonth(calendarState.currentMonth);
    var requestedMonthNumber = utils.getMonth(day);

    if (requestedMonthNumber < currentMonthNumber || requestedMonthNumber > currentMonthNumber + displayingMonthRange) {
      var newMonth = currentlySelectingRangeEnd === 'start' ? start : // If need to focus end, scroll to the state when "end" is displaying in the last calendar
      utils.addMonths(end, -displayingMonthRange);
      changeMonth(newMonth);
    }
  };

  useEffect(function () {
    if (disableAutoMonthSwitching || !open) {
      return;
    }

    if (currentlySelectingRangeEnd === 'start' && start === null || currentlySelectingRangeEnd === 'end' && end === null) {
      return;
    }

    scrollToDayIfNeeded(currentlySelectingRangeEnd === 'start' ? start : end);
  }, [currentlySelectingRangeEnd, date]); // eslint-disable-line

  var handleChange = useCallback(function (newDate) {
    var _calculateRangeChange = calculateRangeChange({
      newDate: newDate,
      utils: utils,
      range: date,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd
    }),
        nextSelection = _calculateRangeChange.nextSelection,
        newRange = _calculateRangeChange.newRange;

    setCurrentlySelectingRangeEnd(nextSelection);
    var isFullRangeSelected = currentlySelectingRangeEnd === 'end' && isRangeValid(utils, newRange);
    onDateChange(newRange, wrapperVariant, isFullRangeSelected ? FORCE_FINISH_PICKER : true);
  }, [currentlySelectingRangeEnd, date, onDateChange, setCurrentlySelectingRangeEnd, utils, wrapperVariant]);

  var renderView = function renderView() {
    var sharedCalendarProps = _objectSpread$1({
      date: date,
      isDateDisabled: isDateDisabled,
      changeFocusedDay: changeFocusedDay,
      onChange: handleChange,
      reduceAnimations: reduceAnimations,
      disableHighlightToday: disableHighlightToday,
      onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
      changeMonth: changeMonth,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      disableFuture: disableFuture,
      disablePast: disablePast,
      minDate: minDate,
      maxDate: maxDate
    }, calendarState, {}, other);

    switch (wrapperVariant) {
      case 'desktop':
        {
          return createElement(DateRangePickerViewDesktop, _extends({
            calendars: calendars
          }, sharedCalendarProps));
        }

      default:
        {
          return createElement(DateRangePickerViewMobile, sharedCalendarProps);
        }
    }
  };

  return createElement(Fragment, null, toShowToolbar && createElement(DateRangePickerToolbar, {
    date: date,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd,
    setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
    startText: startText,
    endText: endText
  }), isMobileKeyboardViewOpen ? createElement(MobileKeyboardInputView, null, createElement(DateRangePickerInput, _extends({
    disableOpenPicker: true,
    ignoreInvalidInputs: true,
    startText: startText,
    endText: endText,
    currentlySelectingRangeEnd: currentlySelectingRangeEnd,
    setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd
  }, DateInputProps))) : renderView());
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function parseRangeInputValue(now, utils, _ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? [null, null] : _ref$value,
      defaultHighlight = _ref.defaultHighlight;
  return value.map(function (date) {
    return date === null ? null : utils.startOfDay(parsePickerInputValue(now, utils, {
      value: date,
      defaultHighlight: defaultHighlight
    }));
  });
}
function makeRangePicker(Wrapper) {
  var WrapperComponent = makeWrapperComponent(Wrapper, {
    KeyboardDateInputComponent: DateRangePickerInput,
    PureDateInputComponent: DateRangePickerInput
  });

  function RangePickerWithStateAndWrapper(_ref2) {
    var calendars = _ref2.calendars,
        minDate = _ref2.minDate,
        maxDate = _ref2.maxDate,
        disablePast = _ref2.disablePast,
        disableFuture = _ref2.disableFuture,
        shouldDisableDate = _ref2.shouldDisableDate,
        showDaysOutsideCurrentMonth = _ref2.showDaysOutsideCurrentMonth,
        onMonthChange = _ref2.onMonthChange,
        disableHighlightToday = _ref2.disableHighlightToday,
        reduceAnimations = _ref2.reduceAnimations,
        value = _ref2.value,
        onChange = _ref2.onChange,
        _ref2$mask = _ref2.mask,
        mask = _ref2$mask === void 0 ? '__/__/____' : _ref2$mask,
        _ref2$variant = _ref2.variant,
        variant = _ref2$variant === void 0 ? 'outlined' : _ref2$variant,
        _ref2$startText = _ref2.startText,
        startText = _ref2$startText === void 0 ? 'Start' : _ref2$startText,
        _ref2$endText = _ref2.endText,
        endText = _ref2$endText === void 0 ? 'End' : _ref2$endText,
        passedInputFormat = _ref2.inputFormat,
        restPropsForTextField = _objectWithoutProperties(_ref2, ["calendars", "minDate", "maxDate", "disablePast", "disableFuture", "shouldDisableDate", "showDaysOutsideCurrentMonth", "onMonthChange", "disableHighlightToday", "reduceAnimations", "value", "onChange", "mask", "variant", "startText", "endText", "inputFormat"]);

    var utils = useUtils();

    var _React$useState = useState('start'),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        currentlySelectingRangeEnd = _React$useState2[0],
        setCurrentlySelectingRangeEnd = _React$useState2[1];

    var pickerStateProps = _objectSpread$2({}, restPropsForTextField, {
      value: value,
      onChange: onChange,
      inputFormat: passedInputFormat || utils.formats.keyboardDate
    });

    var _usePickerState = usePickerState(pickerStateProps, {
      parseInput: parseRangeInputValue,
      areValuesEqual: function areValuesEqual(a, b) {
        return utils.isEqual(a[0], b[0]) && utils.isEqual(a[1], b[1]);
      },
      validateInput: function validateInput() {
        return undefined;
      },
      emptyValue: [null, null]
    }),
        pickerProps = _usePickerState.pickerProps,
        inputProps = _usePickerState.inputProps,
        wrapperProps = _usePickerState.wrapperProps;

    var DateInputProps = _objectSpread$2({}, inputProps, {}, restPropsForTextField, {
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
      startText: startText,
      endText: endText,
      mask: mask,
      variant: variant
    });

    return createElement(WrapperComponent, _extends({
      wrapperProps: wrapperProps,
      inputProps: DateInputProps
    }, restPropsForTextField), createElement(DateRangePickerView, _extends({
      open: wrapperProps.open,
      DateInputProps: DateInputProps,
      calendars: calendars,
      minDate: minDate,
      maxDate: maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      shouldDisableDate: shouldDisableDate,
      showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
      onMonthChange: onMonthChange,
      disableHighlightToday: disableHighlightToday,
      reduceAnimations: reduceAnimations,
      currentlySelectingRangeEnd: currentlySelectingRangeEnd,
      setCurrentlySelectingRangeEnd: setCurrentlySelectingRangeEnd,
      startText: startText,
      endText: endText
    }, pickerProps)));
  }

  return forwardRef(function (props, ref) {
    return createElement(RangePickerWithStateAndWrapper, _extends({}, props, {
      forwardedRef: ref
    }));
  });
} // TODO replace with new export type syntax

var DateRangePicker = makeRangePicker(ResponsivePopperWrapper);
var DesktopDateRangePicker = makeRangePicker(DesktopPopperWrapper);
var MobileDateRangePicker = makeRangePicker(MobileWrapper);
var StaticDateRangePicker = makeRangePicker(StaticWrapper);

export { DateRangePicker, DesktopDateRangePicker, MobileDateRangePicker, StaticDateRangePicker, makeRangePicker, parseRangeInputValue };
//# sourceMappingURL=index.js.map
